import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import { TierLevels } from 'types/session/user'

import {
	ClickMLYActions,
	ImpressionMLYActions,
	SpaceMLYGenericEvents,
	TIER_LEVELS_EVENT_TYPE,
} from '../constants/analytics'
import type { AdvantageType } from '../types/mlySpaceData'

export const sendWelcomeMessageImpressionMLYEvent = (
	tier = TierLevels.TIER_1
) => {
	sendGenericEvent(SpaceMLYGenericEvents.IMPRESSION_MLY, {
		action: ImpressionMLYActions.WELCOME_MESSAGE,
		type: TIER_LEVELS_EVENT_TYPE[tier],
	})
}

export const sendWelcomeMessageClickMLYEvent = (tier = TierLevels.TIER_1) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.WELCOME_MESSAGE,
		type: TIER_LEVELS_EVENT_TYPE[tier],
	})
}

export const sendHistoryClickMLYEvent = () => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.HISTORY,
	})
}

export const sendUnlockExperienceClickMLYEvent = ({
	tier = TierLevels.TIER_1,
	experience,
	index,
}: {
	index: number
	experience: string
	tier: TierLevels | undefined
}) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.UNLOCK_EXPERIENCE,
		type: TIER_LEVELS_EVENT_TYPE[tier],
		label1: experience,
		index,
	})
}

export const sendUnlockNonProfitClickMLYEvent = ({
	tier = TierLevels.TIER_1,
	nonProfit,
}: {
	nonProfit: string
	tier: TierLevels | undefined
}) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.UNLOCK_NON_PROFIT,
		type: TIER_LEVELS_EVENT_TYPE[tier],
		label1: nonProfit,
	})
}

export const sendShowExperienceClickMLYEvent = ({
	tier = TierLevels.TIER_1,
	name,
	index,
}: {
	index: number
	name: string
	tier: TierLevels | undefined
}) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.SHOW_EXPERIENCE,
		type: TIER_LEVELS_EVENT_TYPE[tier],
		label1: name,
		index,
	})
}

export const sendShowDonationClickMLYEvent = ({
	tier = TierLevels.TIER_1,
	name,
	index,
}: {
	index: number
	name: string
	tier: TierLevels | undefined
}) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.SHOW_DONATION,
		type: TIER_LEVELS_EVENT_TYPE[tier],
		label1: name,
		index,
	})
}

export const sendYourAdvantagesClickMLYEvent = ({
	tier = TierLevels.TIER_1,
	type,
}: {
	type: AdvantageType
	tier: TierLevels | undefined
}) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.YOUR_ADVANTAGES,
		type: TIER_LEVELS_EVENT_TYPE[tier],
		label1: type,
	})
}

export const sendUnlockAdvantagesClickMLYEvent = ({
	tier = TierLevels.TIER_1,
	type,
}: {
	type: AdvantageType
	tier: TierLevels | undefined
}) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.UNLOCK_ADVANTAGES,
		type: TIER_LEVELS_EVENT_TYPE[tier],
		label1: type,
	})
}

export const seeMoreClickMLYEvent = (tier = TierLevels.TIER_1) => {
	sendGenericEvent(SpaceMLYGenericEvents.CLICK_MLY, {
		action: ClickMLYActions.HELP_SEE_MORE,
		type: TIER_LEVELS_EVENT_TYPE[tier],
	})
}
